var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageTrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 484 537",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2155.17,-2880.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2638.18,2882.32C2607.2,3207.53 2385.89,3423.91 2155.17,3416.68C2369.1,3358.96 2470.76,3157.74 2435.45,2882.7C2435.28,2881.39 2434.16,2880.41 2432.84,2880.41C2415.93,2880.41 2311.91,2880.41 2311.91,2880.41L2638.36,2880.41L2638.18,2882.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTrail);
export default __webpack_public_path__ + "static/media/message_trail.8fa4462b0ee11d098014d131bcf311af.svg";
export { ForwardRef as ReactComponent };